import React, { useContext, useMemo } from "react";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useDocumentTitle } from "usehooks-ts";
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import { useLocation, useNavigate } from "react-router-dom";
import { NoodleModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { isHttpOK } from "nood-comp/src/net/xhr";
import { queryStringModifier } from "nood-comp/src/util/converters/converters";
import SystemView from "src/routes/orgs/systems/SystemView";
import Systems from "src/routes/orgs/systems/Systems";
import SystemEditor from "src/routes/orgs/systems/SystemEditor";
import { msg } from "src/app/msg";
import { RandomStringGenerator } from "nood-comp/src/util/rand/RandomStringGenerator";
export default function SystemsIndex(props) {
  var _useLocation;
  useDocumentTitle(msg.title(msg.system));
  var id = useURLParam('id');
  var modalCtx = useContext(NoodleModalContext);
  var navigate = useNavigate();
  var queryString = (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.search;
  console.log("SystemsIndex.tsx ", RandomStringGenerator.alphanum(5));
  var items = useMemo(function () {
    return [{
      id: 'list',
      label: 'Systems',
      icon: 'list',
      content: /*#__PURE__*/React.createElement(Systems, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'add',
      label: 'Add',
      icon: 'plus',
      content: /*#__PURE__*/React.createElement(SystemEditor, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'view',
      label: 'View',
      icon: 'eye',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(SystemView, null),
      queryString: {
        id: id
      }
    }, {
      id: 'edit',
      label: 'Edit',
      icon: 'edit-2',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(SystemEditor, null),
      queryString: {
        id: id
      }
    }, {
      id: 'delete',
      label: 'Delete',
      icon: 'x',
      show: id !== null,
      __click: function __click(e) {
        modalCtx.__confirmDelete({
          entity: "System",
          endpoint: "/system/".concat(id),
          __onAfterDelete: function __onAfterDelete(response) {
            if (isHttpOK(response)) {
              navigate(queryStringModifier({
                queryString: queryString,
                modifiers: {
                  "do": "list",
                  id: undefined
                }
              }));
            }
          }
        });
      }
    }];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Systems"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: items
  }));
}